/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration for replicating vault metadata to a separate bucket. This enables reconstruction of DynamoDB records from the vault in case of disaster. 
*/
export class VaultMetadataReplicationConfig {
  /**
  * The bucket ID to replicate metadata to. 
  */
  'replicationBucketId'?: string;
  /**
  * The prefix in the replication bucket where metadata will be stored. 
  */
  'replicationPrefix'?: string;
  /**
  * The AWS region where the replication bucket is located. 
  */
  'replicationRegion'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "replicationBucketId",
      "baseName": "replicationBucketId",
      "type": "string",
      "format": ""
    },
    {
      "name": "replicationPrefix",
      "baseName": "replicationPrefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "replicationRegion",
      "baseName": "replicationRegion",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VaultMetadataReplicationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

